// extracted by mini-css-extract-plugin
module.exports = {"auth":"styles_auth__3BZda","main":"styles_main__2USxy","title":"styles_title__3Wv3i","sub-title":"styles_sub-title__ubWTV","background":"styles_background__1I6zo"};